export default __webpack_public_path__ + "static/media/conversion-icon.11b52c0d.png";